import Event from "../../Components/Event/Event";

const EventPage = () => {
    return (
        <>
            <Event/>
        </>
    )
};

export default EventPage;